export default __webpack_public_path__ + "static/media/125.3395eb04.png";